export default "__VITE_ASSET__B8VY3wpz__"